import Index from '../../pages/hjwq/mentoring/Index';
import InvitationLetter from '../../pages/hjwq/mentoring/invitationLetter';

const base = 'mentoring';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/invitationLetter*`,
    name: `${base}-invitationLetter`,
    component: InvitationLetter
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/mentoring.js